<template>
  <div>
  <q-table
      title="Valores"
      :data="donationsValues"
      :columns="columns"
      row-key="id"
      :loading="isLoading"
    >

    <template v-slot:top="props">
      <div class="row col-11 q-col-gutter-xs">
        <div class="col-11 text-center text-h3">Valores de doação</div>
      </div>
      <div class="col-1 text-center">
        <q-btn color="bg-purple-10" outline icon="add" @click="openModal(value, false)"></q-btn>
      </div>
    </template>

    <template v-slot:body-cell-options="value">
      <q-td>
        <q-btn round color="primary" @click="openModal(value, true)" icon="edit"/>
      </q-td>

      <q-td>
        <q-btn round color="primary" @click="deleteDonationValue(value)" icon="delete"/>
      </q-td>
    </template>
  </q-table>

  <q-dialog v-model="modal.isActive">
      <q-card style="width: 80vw; max-width: 80vw;">
        <DonationValuesForm
          :amount="currentDonationValue.amount"
          :editing="isEditing"
          :id="currentDonationValue.id"
          :onClose="(updatedValue) => {
            updateCurrentDonationValue(updatedValue);
            toggleModal(false);
          }"
        />

        <q-inner-loading :showing="modal.isLoading">
          <q-spinner-dots size="50px" color="primary"/>
        </q-inner-loading>

        <br>
        <br>

      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { setupAxios } from '../views/microfrontend/setupAxios';
import { getDonationValues, deleteDonationValue } from '../views/microfrontend/apiClient';
import DonationValuesForm from '../views/microfrontend/DonationsManager/DonationValues/DonationValuesForm';
import { numberToReal } from '../helpers';
export default {
  name: 'DonationValues',
  components: { DonationValuesForm },
  data () {
    return {
      donationsValues: [],
      columns: [
        {
          name: 'id',
          label: 'ID',
          align: 'left',
          field: 'id'
        },
        {
          name: 'amount',
          label: 'Valor',
          align: 'left',
          field: 'amount',
          format: (n) => numberToReal(n)
        },
        {
          name: 'created_by',
          label: 'Última atualização por',
          align: 'left',
          field: 'created_by'
        },
        {
          name: 'updated_at',
          label: 'Última atualização em',
          align: 'left',
          field: 'updated_at'
        }, {
          name: 'options',
          label: 'Editar',
          align: 'left',
          field: 'options',
          required: true
        },
        {
          name: 'delete',
          label: 'Deletar',
          align: 'left',
          field: 'delete',
          required: true
        },
      ],
      modal: {
        isActive: false,
        isLoading: false
      },
      currentDonationValue: {
        id: undefined,
        amount: 0,
        created_by: undefined,
        updated_at: undefined

      },
      isEditing: false,
      isLoading: true
    };
  },
  async mounted () {
    this.axios = setupAxios();
    this.donationsValues = (await getDonationValues(this.axios)).data;
    this.isLoading = false;
  },
  methods: {
    openModal (value, isEditing) {
      this.isEditing = isEditing;
      this.toggleModal(true);
      this.currentDonationValue.id = isEditing ? value.row.id : undefined;
      this.currentDonationValue.amount = isEditing ? value.row.amount : undefined;
    },
    async deleteDonationValue (value) {
      this.isLoading = true;
      const res = await deleteDonationValue(this.axios, value.row.id);
      if (res && res.status === 200) {
        alert('Valor de doação deletado!');
        this.handleDeleteDonationValue(res.data.donationValue);
      }
      this.isLoading = false;
    },
    async createDonationValue () {
      await this.getDonators();
    },
    toggleModal (toggle) {
      this.modal.isActive = toggle;
    },
    handleDeleteDonationValue (updatedValue) {
      this.donationsValues = this.donationsValues.filter(d => {
        return d.id !== updatedValue.id;
      });
    },
    handleNewDonationValue (newValue) {
      this.donationsValues.push(newValue);
    },
    handleUpdateDonationValue (updatedValue) {
      this.currentDonationValue.amount = updatedValue.amount;
      this.currentDonationValue.updated_at = updatedValue.updated_at;
      this.currentDonationValue.created_by = updatedValue.created_by;

      this.donationsValues = this.donationsValues.map(d => {
        if (d.id === updatedValue.id) {
          return this.currentDonationValue;
        }
        return d;
      });
    },
    updateCurrentDonationValue (updatedValue) {
      if (this.isEditing) {
        this.handleUpdateDonationValue(updatedValue);
      } else {
        this.handleNewDonationValue(updatedValue);
      };
    }
  }
};
</script>

<style scoped>

</style>

